import { Component, Input, OnInit } from '@angular/core';
import { StockData } from '../services/stockBase';
import { jkLib } from 'jk-service';
import { JkBaseComponent } from 'jk-service';

@Component({
  selector: 'app-stock-view01',
  standalone: true,
  imports: [],
  templateUrl: './stock-view01.component.html',
  styleUrl: './stock-view01.component.css',
})
export class StockView01Component extends JkBaseComponent implements OnInit {
  amount(): string {
    if (!this.data) return '';
    if (!this.data.qty) return '';
    if (isNaN(this.data.close)) return '';
    let r = this.round(this.data.qty * this.data.close / 10000);
    return r;
  }
  constructor() {
    super();
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  _data!: StockData;// = new StockData();
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set data(d: StockData) {
    if (d) {
      this._data = d;
    }
  }
  get data(): StockData {
    if (!this._data) this._data = new StockData();
    return this._data;
  }

  formatPercent(n: number, digit: number): string {
    return jkLib.percentStr(n, digit);
  }
  round(arg0: number): string {
    return String(Math.round(arg0));
  }
  checkDir(arg0: number): string {
    if (arg0 === 0) {
      return '';
    } else if (arg0 > 0) {
      return '▲';
    } else {
      return '▼';
    }
  }
  checkStyle(n: number): string {
    let s = '';
    if (n === 0) {
      s = 's-number-white';
    } else if (n > 0) {
      s = 's-number-red';
    } else if (n < 0) {
      s = 's-number-green';
    }
    return s;
  }
  FormattedDate(): string {
    if (!this.data) return '';
    return jkLib.date2Display(this.data.date, '/');
  }

}
